import React from 'react';
import { Select } from 'components/FormFields';
import Images from 'images';
import { railIcons } from '../../NavLayout/config/navIcons';
import {
  Drawer,
  DrawerHeader,
  DrawerHeaderLogo,
  DrawerCloseButton,
  DrawerBody,
  DrawerAccountRow,
  DrawerFooter,
  DrawerFooterItem,
  DrawerAvatar,
  MobileIcon,
} from '../styled/NavMobileLayout.styled';
import MobileMenuSection from './MobileMenuSection';

const platform = process.env.REACT_APP_PLATFORM;

const getDrawerLogo = () => {
  if (platform === 'tickethoss') return Images.hossHeadRail;
  if (platform === 'kartpass') return Images.logoKart;
  return Images.pitpayStacked;
};

const MobileDrawer = ({
  isVisible,
  sections,
  activeSection,
  onClose,
  onNavigate,
  // Account
  showAccountSelector,
  account,
  accountOptions,
  onAccountChange,
  // Actions
  onThemeToggle,
  onSettingsClick,
  onStripeClick,
  onPermissionDenied,
  user,
}) => {
  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`
    : '';
  const fullName = user
    ? `${user.first_name || ''} ${user.last_name || ''}`
    : '';

  const handleClose = (link) => {
    onClose();
    if (link) {
      onNavigate(link);
    }
  };

  return (
    <Drawer isVisible={isVisible}>
      <DrawerHeader>
        <DrawerHeaderLogo src={getDrawerLogo()} alt={platform} />
        <DrawerCloseButton onClick={onClose}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </DrawerCloseButton>
      </DrawerHeader>

      <DrawerBody>
        {showAccountSelector && (
          <DrawerAccountRow>
            <Select
              placeholder="Select Account"
              value={account?.value ?? ''}
              onChange={(e) => {
                const selected = (accountOptions || []).find(
                  (o) => String(o.value) === e.target.value
                );
                if (selected) {
                  onAccountChange(selected);
                  onClose();
                }
              }}
              options={accountOptions || []}
            />
          </DrawerAccountRow>
        )}

        {sections.map((section) => (
          <MobileMenuSection
            key={section.id}
            section={section}
            isActive={activeSection === section.id}
            onClose={handleClose}
            onStripeClick={onStripeClick}
            onPermissionDenied={onPermissionDenied}
          />
        ))}

        <DrawerFooter>
          <DrawerFooterItem onClick={onThemeToggle}>
            <MobileIcon viewBox="0 0 24 24">{railIcons.theme}</MobileIcon>
            Light Mode
          </DrawerFooterItem>

          <DrawerFooterItem
            onClick={() => {
              onSettingsClick();
              onClose();
            }}
          >
            <DrawerAvatar>{initials}</DrawerAvatar>
            {fullName}
          </DrawerFooterItem>
        </DrawerFooter>
      </DrawerBody>
    </Drawer>
  );
};

export default MobileDrawer;
